import { useTranslation } from 'react-i18next'

import { getTrackingPageBlocks, TrackingPageGrid as SharedTrackingPageGrid } from '@reveni-io/reveni-ui'

import { previewViewModes } from '@/configuration/pages/ConfigurationPage/OrderTrackingPageConfiguration/constants'
import {
  getBlockDefinitions,
  getPreviewRecommendedProducts,
} from '@/configuration/pages/ConfigurationPage/OrderTrackingPageConfiguration/helpers'
import { getBlockErrorCount } from '@/configuration/pages/ConfigurationPage/OrderTrackingPageConfiguration/TrackingPageEditorModal/hooks/useBlockErrors/helpers'

import BlockPreview from './BlockPreview/BlockPreview'
import GridBlockContent from './GridBlockContent/GridBlockContent'
import { getGridInteraction, getResizableLayout, getVisibleLayout } from './helpers'
import * as Styles from './styles'

import 'react-grid-layout/css/styles.css'

const TrackingPageGrid = ({
  orderTrackingPreview,
  viewMode,
  layout,
  blockSettings,
  blockVisibility,
  blockErrors,
  hiddenBlocks,
  showHiddenBlocks,
  timeZone,
  editorContext,
  getRecommendedProductsService,
  onLayoutChange,
  onLayoutChangeStart,
  onLayoutChangeCommit,
  onBlockHeightChange,
  onBlockResize,
  selectedBlockId,
  onSelectBlock,
  onRemoveBlock,
}) => {
  const { t } = useTranslation()

  const isDesktop = viewMode === previewViewModes.desktop
  const isLayoutLocked = !showHiddenBlocks
  const visibleLayout = isLayoutLocked ? getVisibleLayout(layout, hiddenBlocks) : layout

  const blocks = getTrackingPageBlocks({
    layout: visibleLayout,
    blockDefinitions: getBlockDefinitions({
      fallbackRecommendedProducts: getPreviewRecommendedProducts(t),
      getRecommendedProductsService,
    }),
    orderTrackingInfo: orderTrackingPreview,
    t,
    blockSettings,
    editorContext,
  }).map(block => {
    const errorCount = getBlockErrorCount(blockErrors, block.id)

    return {
      ...block,
      hasErrors: errorCount > 0,
      content: (
        <BlockPreview
          blockId={block.id}
          content={
            <GridBlockContent
              block={block}
              hiddenReasons={hiddenBlocks[block.id]}
              blockSettings={blockSettings}
              isMobileView={!isDesktop}
            />
          }
          visibility={blockVisibility[block.id]}
          timeZone={timeZone}
          errorCount={errorCount}
        />
      ),
    }
  })
  const gridInteraction = getGridInteraction({ isLayoutLocked, viewMode, onLayoutChange })
  const resizableLayout = getResizableLayout(visibleLayout, selectedBlockId, isDesktop && !isLayoutLocked)

  return (
    <Styles.Container viewMode={viewMode}>
      <SharedTrackingPageGrid
        blocks={blocks}
        viewMode={viewMode}
        layout={resizableLayout}
        dragConfig={gridInteraction.dragConfig}
        resizeConfig={gridInteraction.resizeConfig}
        onLayoutChange={gridInteraction.onLayoutChange}
        onLayoutChangeStart={onLayoutChangeStart}
        onLayoutChangeCommit={onLayoutChangeCommit}
        onBlockHeightChange={onBlockHeightChange}
        onBlockResize={onBlockResize}
        selectedBlockId={selectedBlockId}
        onSelectBlock={onSelectBlock}
        onRemoveBlock={onRemoveBlock}
      />
    </Styles.Container>
  )
}

export default TrackingPageGrid
